"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unmutePromiseError = exports.mutePromiseError = void 0;
function mutePromiseError(rawPromise) {
    return rawPromise.then(function (result) {
        var r = {
            isError: false,
            result: result,
        };
        return r;
    }, function (error) {
        var r = {
            isError: true,
            error: error,
        };
        return r;
    });
}
exports.mutePromiseError = mutePromiseError;
function unmutePromiseError(mutedPromise) {
    return mutedPromise.then(function (mutedResult) {
        if (mutedResult.isError) {
            return Promise.reject(mutedResult.error);
        }
        return Promise.resolve(mutedResult.result);
    });
}
exports.unmutePromiseError = unmutePromiseError;
//# sourceMappingURL=mute-promise-error.js.map